
	<div class="row">
		<div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3" *ngFor="let workAddress of user.WORK_ADDRESSES; index as i">			
				{{workAddress.STREET_1}} <br />
				<span ng-if="workAddress.STREET_2">{{workAddress.STREET_2}} <br /></span>
				{{workAddress.CITy.CITY_NAME}}, {{workAddress.CITy.STATE.STATE_CODE}}
				{{workAddress.POSTAL_CODES.POSTAL_CODE}} <br />
				<hr />
			
		</div>
	</div>
